export function accordion() {
  jQuery(function () {
    jQuery(".accordion-list__data").hide();
    jQuery(".accordion-list__term").on("click", function () {
      if (jQuery(this).hasClass("is-opened")) {
        jQuery(this).removeClass("is-opened");
        jQuery(this).next(".accordion-list__data").slideUp();
      } else {
        jQuery(this).addClass("is-opened");
        jQuery(this).next(".accordion-list__data").slideDown();
      }
    });
  });
}
